import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FeatureEditRequestBody, FeatureEditResponse } from "./types";

export class FeatureEditAPI extends BaseAPI<
    FeatureEditRequestBody,
    FeatureEditResponse
> {
    protected route = ApiRoutes.feature.edit;
    protected method = RequestMethod.PUT;
    protected params = ["id"]
}
